module.exports = __webpack_public_path__ + "img/milestone__10.a68dae68.jpg";